import axios from 'axios';
import endpointPaths from './endpointPaths';

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data

    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error

    if (error.response.status === 401) {
        localStorage.removeItem('accessToken')
        setTimeout(() => {
            window.location.href = '/login'
        }, 1000);
    } else {
        return Promise.reject(error);
    }

});

let accessToken = localStorage.accessToken

let axiosConfigApplicationJsonNoAuth = {
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    }
};

let axiosConfigApplicationJson = {
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': `Bearer ${accessToken}`
    }
};

let axiosConfigMultipartFormData = {

    headers: {
        'Content-Type': 'multipart/form-data',
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': `Bearer ${accessToken}`
    }
};


export class Endpoints {

    constructor() {
        this.setAuthorizationToken()
    }
    // Auth Start 
    setAuthorizationToken() {
        accessToken = localStorage.getItem('accessToken')
        axiosConfigApplicationJson = {
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Authorization': `Bearer ${accessToken}`
            }
        };
        axiosConfigMultipartFormData = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-Requested-With': 'XMLHttpRequest',
                'Authorization': `Bearer ${accessToken}`
            }
        };
    }

    postLogin = async (req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.auth.login}?locale=${locale}`, req, axiosConfigApplicationJsonNoAuth);
            return response.data;
        } catch (error) {
            if (error.response) {
                if (error.response.status === 422) {
                    const errors = error.response.data.errors || {};
                    console.log('Form Hataları:', errors);
                }
                return error.response.data;
            } else {
                return { message: 'Bir ağ hatası oluştu. Lütfen tekrar deneyin.' };
            }
        }

    }

    postVerification = async (req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.auth.verification}?locale=${locale}`, req, axiosConfigApplicationJsonNoAuth);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    postPasswordChange = async (req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.auth.passwordChange}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    postPasswordChangeExpired = async (req, locale) => {
        try {
            let response = await axios.post(`${endpointPaths.auth.passwordChangeExpired}?locale=${locale}`, req, axiosConfigApplicationJsonNoAuth);
            return response.data;
        } catch (error) {
            if (error.response) {
                if (error.response.status === 422) {
                    const errors = error.response.data.errors || {};
                    console.log('Form Hataları:', errors);
                }
                return error.response.data;
            } else {
                return { message: 'Bir ağ hatası oluştu. Lütfen tekrar deneyin.' };
            }
        }
    };

    // Auth End 
    // Users Start 

    postUsers = async (req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.users.post}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getUsers = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.users.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    // Users End 
    // Events Start 
    getEvents = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.events.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getEventsBySlug = async (slug, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.events.get}/${slug}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getEventTypes = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.eventTypes.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postEvents = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.events.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putEvents = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.events.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postEventsTranslation = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.events.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postEventsAvailability = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.events.postAvailability}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putEventsOrder = async (req, locale, res) => {
        try {
            const response = await axios.put(`${endpointPaths.events.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteEvents = async (slug, locale, res) => {
        try {
            const response = await axios.delete(`${endpointPaths.events.delete}/${slug}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    // Sliders Start 
    getSliders = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.sliders.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getSlidersById = async (id, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.sliders.get}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postSliders = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.sliders.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putSliders = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.sliders.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postSlidersTranslation = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.sliders.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putSlidersOrder = async (req, locale, res) => {
        try {
            const response = await axios.put(`${endpointPaths.sliders.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteSliders = async (id, locale, res) => {
        try {
            const response = await axios.delete(`${endpointPaths.sliders.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    // Educators Start 
    getEducators = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.educators.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    // Educators Start 
    getEducatorsType = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.educators.get}?locale=${locale}&type=${req}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getEducatorsBySlug = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.educators.get}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postEducators = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.educators.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putEducators = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.educators.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postEducatorsTranslation = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.educators.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postEducatorsAvailability = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.educators.postAvailability}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putEducatorsOrder = async (req, locale, res) => {
        try {
            const response = await axios.put(`${endpointPaths.educators.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteEducators = async (id, locale, res) => {
        try {
            const response = await axios.delete(`${endpointPaths.educators.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    // Contents Start 
    postContentsTranslation = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.contents.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postContents = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.contents.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putContents = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.contents.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getContents = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.contents.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getContentsBySlug = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.contents.get}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getContentsByCategorySlug = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.contents.getByCategorySlug}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postContentsAvailability = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.contents.postAvailability}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putContentsOrder = async (req, locale, res) => {
        try {
            const response = await axios.put(`${endpointPaths.contents.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteContents = async (id, locale, res) => {
        try {
            const response = await axios.delete(`${endpointPaths.contents.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    //  Books Start 

    getBooks = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.books.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getBooksById = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.books.get}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postBooks = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.books.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putBooks = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.books.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postBooksTranslation = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.books.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putBooksOrder = async (req, locale, res) => {
        try {
            const response = await axios.put(`${endpointPaths.books.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteBooks = async (id, locale, res) => {
        try {
            const response = await axios.delete(`${endpointPaths.books.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    //  Podcasts Start 

    getPodcasts = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.podcasts.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getPodcastsBySlug = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.podcasts.get}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postPodcasts = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.podcasts.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putPodcasts = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.podcasts.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postPodcastsTranslation = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.podcasts.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putPodcastsOrder = async (req, locale, res) => {
        try {
            const response = await axios.put(`${endpointPaths.podcasts.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postPodcastsAvailability = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.podcasts.postAvailability}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    deletePodcasts = async (id, locale, res) => {
        try {
            const response = await axios.delete(`${endpointPaths.podcasts.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    //  Categories Start 
    getCategories = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.categories.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getCategoriesTree = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.categories.getTree}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getCategoriesBySlug = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.categories.get}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getCategoriesBySlugFlat = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.categories.getFlat}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getCategoriesAttributesById = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.categories.getAttributes}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getCategoryAttributes = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.categoryAttributes.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postCategories = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.categories.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postCategoriesTranslation = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.categories.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putCategories = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.categories.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putCategoriesOrder = async (req, locale, res) => {
        try {
            const response = await axios.put(`${endpointPaths.categories.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteCategories = async (id, locale, res) => {
        try {
            const response = await axios.delete(`${endpointPaths.categories.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    getGalleriesBySlug = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.galleries.get}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putGalleries = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.galleries.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postGalleries = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.galleries.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postGalleriesAvailability = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.galleries.postAvailability}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getGalleries = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.galleries.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postGalleriesTranslation = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.galleries.postTranslation}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postGalleriesTranslation = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.galleries.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putGalleriesOrder = async (req, locale, res) => {
        try {
            const response = await axios.put(`${endpointPaths.galleries.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteGalleries = async (id, locale, res) => {
        try {
            const response = await axios.delete(`${endpointPaths.galleries.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    getSettingsSliderHighlights = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.settingsSliderHighlights.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postSettingsSliderHighlights = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.settingsSliderHighlights.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putSettingsSliderHighlightsOrder = async (req, locale, res) => {
        try {
            const response = await axios.put(`${endpointPaths.settingsSliderHighlights.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteSettingsSliderHighlights = async (id, locale, res) => {
        try {
            const response = await axios.delete(`${endpointPaths.settingsSliderHighlights.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getSettingsSliderPrograms = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.settingsSliderPrograms.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postSettingsSliderPrograms = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.settingsSliderPrograms.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putSettingsSliderProgramsOrder = async (req, locale, res) => {
        try {
            const response = await axios.put(`${endpointPaths.settingsSliderPrograms.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteSettingsSliderPrograms = async (id, locale, res) => {
        try {
            const response = await axios.delete(`${endpointPaths.settingsSliderPrograms.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getSettingsSliderInteresteds = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.settingsSliderInteresteds.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postSettingsSliderInteresteds = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.settingsSliderInteresteds.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putSettingsSliderInterestedsOrder = async (req, locale, res) => {
        try {
            const response = await axios.put(`${endpointPaths.settingsSliderInteresteds.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteSettingsSliderInteresteds = async (id, locale, res) => {
        try {
            const response = await axios.delete(`${endpointPaths.settingsSliderInteresteds.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getSettingsSliderPodcasts = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.settingsSliderPodcasts.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postSettingsSliderPodcasts = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.settingsSliderPodcasts.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    deleteSettingsSliderPodcasts = async (id, locale, res) => {
        try {
            const response = await axios.delete(`${endpointPaths.settingsSliderPodcasts.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    getSliderLinkTypes = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.sliderLinkTypes.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getGalleryCategories = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.galleryCategories.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getLanguages = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.languages.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getCategoryTypes = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.categoryTypes.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    getContentTypes = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.contentTypes.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getFormContacts = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.form.contacts.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getFormExplicitConsentTexts = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.form.explicitConsentTexts.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getFormCompanyActivities = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.form.companyActivities.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getFormNewsletters = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.form.newsletters.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getFormParticipants = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.form.participants.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    postMedias = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.medias.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    getMedias = async (page, startDate, endDate, name, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.medias.get}?startDate=${startDate}&endDate=${endDate}&name=${name}&page=${page}&locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }


    postNewsletters = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.newsletters.post}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    getNewsletters = async (page, startDate, endDate, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.newsletters.get}?startDate=${startDate}&endDate=${endDate}&page=${page}&locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    // Popups Start 
    getPopups = async (req, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.popups.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getPopupsById = async (id, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.popups.getById}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postPopups = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.popups.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putPopups = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.popups.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postPopupsTranslation = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.popups.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putPopupsOrder = async (req, locale, res) => {
        try {
            const response = await axios.put(`${endpointPaths.popups.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deletePopups = async (id, locale, res) => {
        try {
            const response = await axios.delete(`${endpointPaths.popups.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    // Popups End 


    //Catalog Start
    //Start Catalog Categories
    getCatalogCategories = async (page, limit, locale, res) => {
        try {
            const response = await axios
                .get(`${endpointPaths.catalog.categories.get}?page=${page}&limit=${limit}&locale=${locale}`,
                    axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    postCatalogCategoriesTranslation = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.catalog.categories.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    getCatalogCategoriesById = async (id, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.catalog.categories.get}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putCatalogCategories = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.catalog.categories.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    putCatalogCategoriesOrder = async (req, limit, page, locale, res) => {
        try {
            const response = await axios
                .put(`${endpointPaths.catalog.categories.order}?page=${page}&limit=${limit}&locale=${locale}`,
                    req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    //End Catalog Categories
    //Start Catalog Sub 
    getCatalogSubCategories = async (page, limit, locale, res) => {
        try {
            const response = await axios
                .get(`${endpointPaths.catalog.subCategories.get}?page=${page}&limit=${limit}&locale=${locale}`,
                    axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getCatalogSubCategoriesById = async (id, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.catalog.subCategories.get}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postCatalogSubCategoriesTranslation = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.catalog.subCategories.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    putCatalogSubCategories = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.catalog.subCategories.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }


    putCatalogSubCategoriesOrder = async (req, limit, page, locale, res) => {
        try {
            const response = await axios
                .put(`${endpointPaths.catalog.subCategories.order}?page=${page}&limit=${limit}&locale=${locale}`,
                    req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    //End Catalog Sub 
    //Start Catalog Brands 
    getCatalogBrands = async (page, limit, locale, res) => {
        try {
            const response = await axios
                .get(`${endpointPaths.catalog.brands.get}?page=${page}&limit=${limit}&locale=${locale}`,
                    axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getCatalogBrandsById = async (id, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.catalog.brands.get}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    postCatalogBrandsTranslation = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.catalog.brands.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }


    putCatalogBrands = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.catalog.brands.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }


    putCatalogBrandsOrder = async (req, limit, page, locale, res) => {
        try {
            const response = await axios
                .put(`${endpointPaths.catalog.brands.order}?page=${page}&limit=${limit}&locale=${locale}`,
                    req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    //End Catalog Brands 
    //Start Catalog Products 
    getCatalogProducts = async (page, limit, locale, res) => {
        try {
            const response = await axios
                .get(`${endpointPaths.catalog.products.get}?page=${page}&limit=${limit}&locale=${locale}`,
                    axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getCatalogProductsById = async (id, locale, res) => {
        try {
            const response = await axios.get(`${endpointPaths.catalog.products.get}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    postCatalogProductsTranslation = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.catalog.products.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    putCatalogProducts = async (req, locale, res) => {
        try {
            const response = await axios.post(`${endpointPaths.catalog.products.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    putCatalogProductsOrder = async (req, limit, page, locale, res) => {
        try {
            const response = await axios
                .put(`${endpointPaths.catalog.products.order}?page=${page}&limit=${limit}&locale=${locale}`,
                    req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }



    //Catalog End
}